<!--
 - Author : wanghongling.
 - Date   : 2021/1/7.
 - File   : peopleStream.人流趋势
 -->

<template>
  <layer title="今日人流量统计" width="410px">
    <my-line :id="'stream'+Math.random()" :lineList="peopleLineList"></my-line>
  </layer>
</template>

<script>
  export default {
    name: 'nameStream',
    data () {
      return {
        orgId: this.$store.getters.userInfo.orgId,
        peopleList: [
          {
            name: '小红的食堂',
            peopleHourList: [
              {
                time: '00:00-06:00',
                inPeople: 0
              },
              {
                time: '06:00-08:00',
                inPeople: 0
              },
              {
                time: '08:00-10:00',
                inPeople: 0
              },
              {
                time: '10:00-12:00',
                inPeople: 0
              },
              {
                time: '12:00-14:00',
                inPeople: 0
              },
              {
                time: '14:00-16:00',
                inPeople: 11
              },
              {
                time: '16:00-18:00',
                inPeople: 0
              },
              {
                time: '18:00-20:00',
                inPeople: 10
              },
              {
                time: '20:00-22:00',
                inPeople: 0
              },
              {
                time: '22:00-24:00',
                inPeople: 0
              }
            ]
          },
          {
            name: '不要删除',
            peopleHourList: [
              {
                time: '00:00-06:00',
                inPeople: 0
              },
              {
                time: '06:00-08:00',
                inPeople: 0
              },
              {
                time: '08:00-10:00',
                inPeople: 0
              },
              {
                time: '10:00-12:00',
                inPeople: 0
              },
              {
                time: '12:00-14:00',
                inPeople: 0
              },
              {
                time: '14:00-16:00',
                inPeople: 0
              },
              {
                time: '16:00-18:00',
                inPeople: 0
              },
              {
                time: '18:00-20:00',
                inPeople: 0
              },
              {
                time: '20:00-22:00',
                inPeople: 0
              },
              {
                time: '22:00-24:00',
                inPeople: 0
              }
            ]
          }
        ],
        peopleLineList: {
          position: 'top', // 折线图指示表停留的位置
          margin: '8px auto 0',
          height: '310px',
          yName: '人',
          rotate: 40,//横坐标字体倾斜
          boundaryGap: true,
          padding: [20, 4, 5, 2000],
          smooth: true,
          grid: {
            left: '10%',
            right: '2%',
            bottom: '0%',
            top: '20%'
          },
          toolTipFormatter: '01',
          lineWidth: 2,
          symbolSize: 4,
          opacity: 0,
          xData: [],
          list: {
            name: [],
            showSymbol: false,
            lineColor: ['#d40b0f', '#00bdfb', '#a759fa', '#01f1ab', '#d8a607', '#086bff', '#60c10b', '#88fe1f','#d40b0f', '#00bdfb', '#a759fa', '#01f1ab', '#d8a607', '#086bff', '#60c10b', '#88fe1f'],
            data: []
          }
        }
      }
    },
    props: {
      selectOrgId: {}
    },
    watch: {
      selectOrgId: {
        handler(cur) {
          this.orgId = cur
          this.peopleStreamList()
        },
        deep: true
      }
    },
    mounted () {
      this.orgId = this.$store.getters.userInfo.orgId
      this.peopleStreamList()
    },
    methods: {
      /**
       * @Description:人流量-获取今日人流量按小时统计
       * @author wanghongling
       * @createDate 2021/1/8
      */
      peopleStreamList() {
        this.$request.peopleStreamPerHourList({orgId: this.orgId}).then(result => {
          console.error('人流量-获取今日人流量按小时统计', result)
          if(this.$utils.isEmptyObject(result)) return
          if(this.$utils.isEmptyObject(result.data))return
          if (!result.data.length) return
          let hour = new Date().getHours();
          let res = result.data
          let begin = 0
          let end = 10
          if(hour >10){
            begin = hour-10
            end = hour+1
          }
          for(let i=0;i<res.length;i++){
            res[i].peopleHourList = res[i].peopleHourList.slice(begin,end)
          }

          this.peopleLineList.list.name = res.map(res => {
            return res.name
          })
          this.peopleLineList.xData = res[0].peopleHourList.map(res => {
            return res.time
          })
          this.peopleLineList.list.data = res.map(res => {
            let arr = []
             res.peopleHourList.map(val => {
               arr.push(val.inPeople)
            })
            return arr
          })
          if(this.peopleLineList.list.name.length > 6) {
            this.peopleLineList.grid.top = '30%'
            this.peopleLineList.height = '295px'
          }
          console.error('this.peopleLineList.list.name', this.peopleLineList.list.data)
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/peopleStream.vue